"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityQuoteComparisonReport = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_entity_1 = require("./opportunity.entity");
const look_up_entity_1 = require("./look-up.entity");
const opportunity_activity_map_entity_1 = require("./opportunity-activity-map.entity");
const opportunity_quote_comparison_report_document_map_entity_1 = require("./opportunity-quote-comparison-report-document-map.entity");
let OpportunityQuoteComparisonReport = class OpportunityQuoteComparisonReport {
    constructor(opportunityId, activityId, opportunityActivityId, statusLid, insuranceMarket, clientSpecific, issuesFaced, industryBenchmarkingComments, analysisRecommendation, overallComments, remarks, createdBy, updatedBy) {
        this.opportunityId = opportunityId;
        this.activityId = activityId;
        this.opportunityActivityId = opportunityActivityId;
        this.statusLid = statusLid;
        this.insuranceMarket = insuranceMarket;
        this.clientSpecific = clientSpecific;
        this.issuesFaced = issuesFaced;
        this.industryBenchmarkingComments = industryBenchmarkingComments;
        this.analysisRecommendation = analysisRecommendation;
        this.overallComments = overallComments;
        this.remarks = remarks;
        this.createdBy = createdBy;
        this.updatedBy = updatedBy;
    }
};
exports.OpportunityQuoteComparisonReport = OpportunityQuoteComparisonReport;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityQuoteComparisonReport.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityQuoteComparisonReport.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "activity_id", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityQuoteComparisonReport.prototype, "activityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_activity_id", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityQuoteComparisonReport.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "status_lid", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityQuoteComparisonReport.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "insurance_market", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityQuoteComparisonReport.prototype, "insuranceMarket", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "client_specific", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityQuoteComparisonReport.prototype, "clientSpecific", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "issues_faced", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityQuoteComparisonReport.prototype, "issuesFaced", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "industry_benchmarking_comments",
        type: "text",
        nullable: true,
    }),
    tslib_1.__metadata("design:type", String)
], OpportunityQuoteComparisonReport.prototype, "industryBenchmarkingComments", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "analysis_recommendation", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityQuoteComparisonReport.prototype, "analysisRecommendation", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "overall_comments", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityQuoteComparisonReport.prototype, "overallComments", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "remarks", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityQuoteComparisonReport.prototype, "remarks", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityQuoteComparisonReport.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityQuoteComparisonReport.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], OpportunityQuoteComparisonReport.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: "updated_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], OpportunityQuoteComparisonReport.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_entity_1.Opportunity, (opportunity) => opportunity.id, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "opportunity_id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityQuoteComparisonReport.prototype, "opportunity", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_activity_map_entity_1.OpportunityActivityMap, (activityMap) => activityMap.id, {
        onDelete: "SET NULL",
    }),
    (0, typeorm_1.JoinColumn)({ name: "opportunity_activity_id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityQuoteComparisonReport.prototype, "opportunityActivity", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => look_up_entity_1.LookUp, { onDelete: "SET NULL" }),
    (0, typeorm_1.JoinColumn)({ name: "status_lid" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityQuoteComparisonReport.prototype, "status", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => opportunity_quote_comparison_report_document_map_entity_1.OpportunityQuoteComparisonReportDocumentMap, (doc) => doc.quoteComparisonReport),
    tslib_1.__metadata("design:type", Object)
], OpportunityQuoteComparisonReport.prototype, "documents", void 0);
exports.OpportunityQuoteComparisonReport = OpportunityQuoteComparisonReport = tslib_1.__decorate([
    (0, typeorm_1.Entity)("opportunity_quote_comparison_report"),
    tslib_1.__metadata("design:paramtypes", [Number, Number, Number, Number, String, String, String, String, String, String, String, Number, Number])
], OpportunityQuoteComparisonReport);
